export default function initNewsletterForm() {
  Alpine.data('newsletterForm', () => ({
    submitting: true,
    email: '',
    name: '',
    nameError: '',
    emailError: '',
    init() {
      const form = this.$el.querySelector('form');
      if (form) {
        const observer = new MutationObserver(() => {
          this.submitting = form.querySelectorAll('[name="CRAFT_CSRF_TOKEN"]').length === 0;
        });

        // Configure observer: watch children for additions
        observer.observe(form, { childList: true, subtree: true });
        this.submitting = form.querySelectorAll('[name="CRAFT_CSRF_TOKEN"]').length === 0;
      }
    },
    validateForm() {
      if (this.name.trim() === '') {
        this.nameError = window.GLOBAL_TRANSLATES.name_required;
      } else {
        this.nameError = '';
      }
      const emailPattern = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

      if (this.email.trim() === '' || !emailPattern.test(this.email)) {
        this.emailError = window.GLOBAL_TRANSLATES.email_invalid;
      } else {
        this.emailError = '';
      }
      return this.emailError === '' && this.nameError === '';
    },
    handleSubmit(event: FormDataEvent) {
      if (this.submitting) {
        return;
      }
      if (this.validateForm()) {
        this.submitting = true;

        const form = event.target as HTMLFormElement;
        fetch('/', {
          method: 'POST',
          body: new FormData(form),
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          redirect: 'manual',
        })
          .then((response) => response.json())
          .then((data) => {
            this.submitting = false;

            if (data.success) {
              this.email = '';
              this.name = '';
              this.openSuccessDialog();
            }
          })
          .catch(() => {
            this.submitting = false;
          });
      }
    },
    openSuccessDialog() {
      const dialog = document.getElementById('newsletter-signup-dialog');
      // @ts-ignore
      dialog.show();
    },
  }));
}
